import script from "./nueva.vue?vue&type=script&setup=true&lang=js"
export * from "./nueva.vue?vue&type=script&setup=true&lang=js"

import "./nueva.vue?vue&type=style&index=0&id=5727ab2b&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Proyectos/Vue/cotizador-ventus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5727ab2b"]])

export default __exports__